import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo, useState } from 'react';
import { getVCookie } from '@chegg/utils';
import { OneClick } from '@chegg/one-click';
import { CheggAndEComEnvMap } from './constants';
import { getIsAuthenticated } from '../../utils/getIsAuthenticated';
import { getCheckoutAuthParams } from '../../utils/checkoutAuthorization';
import { getHostAnnotations, ProductType } from '@chegg/commerce-utils';
import { useCheckout } from '../../hooks/useCheckout';
import { Screen } from './types';
import { getOneClickResponseCallback } from './utils/getOneClickResponseCallback';
import SuccessContent from '../SuccessContent';
import StyledContentWrapper from './styled';
import { IconButton } from '@chegg-ui/button';
import { CancelIcon } from '@chegg-ui/theme';
import { colors } from '@chegg-ui/theme';
import { useVBCUser } from '../../hooks/useVBCUser';
var WtOneClick = function WtOneClick(_ref) {
  var productConfig = _ref.productConfig,
    authConfig = _ref.authConfig,
    countryCode = _ref.countryCode,
    analyticsInfo = _ref.analyticsInfo,
    environment = _ref.environment,
    _callback = _ref.callback,
    onHostRedirect = _ref.onHostRedirect,
    siteName = _ref.siteName,
    onClose = _ref.onClose,
    isModal = _ref.isModal;
  var isAuthenticated = getIsAuthenticated();
  var vCookie = useMemo(function () {
    var _getVCookie;
    return (_getVCookie = getVCookie()) !== null && _getVCookie !== void 0 ? _getVCookie : '';
  }, []);
  var authorization = getCheckoutAuthParams(authConfig.sdkKey, environment);
  var ecomEnv = CheggAndEComEnvMap[environment];
  var _useState = useState(Screen.PAYMENT),
    _useState2 = _slicedToArray(_useState, 2),
    screen = _useState2[0],
    setScreen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVbcUserSet = _useState4[0],
    setIsVbcUserSet = _useState4[1];
  var _useVBCUser = useVBCUser({
      isAuthenticated: isAuthenticated,
      authorization: authorization,
      isVbcUserSet: isVbcUserSet,
      setIsVbcUserSet: setIsVbcUserSet
    }),
    vbcError = _useVBCUser.vbcError;
  var _useCheckout = useCheckout({
      countryCode: countryCode,
      analyticsInfo: analyticsInfo,
      skip: !isAuthenticated,
      productConfig: productConfig,
      environment: ecomEnv,
      authorizeParams: authorization
    }),
    loading = _useCheckout.loading,
    oneClickPayload = _useCheckout.oneClickPayload,
    hasError = _useCheckout.hasError;
  var content = null;
  if (isVbcUserSet && !loading && oneClickPayload && !hasError && !vbcError) {
    content = /*#__PURE__*/React.createElement(OneClick, {
      authorization: authorization,
      callback: function callback(hostCallbackPayload) {
        getOneClickResponseCallback({
          hostCallbackPayload: hostCallbackPayload,
          callback: _callback,
          setScreen: setScreen
        });
      },
      country: countryCode,
      environment: ecomEnv,
      pricingDetails: oneClickPayload,
      allowPlanSelection: false,
      withCoupon: false,
      contextProductType: siteName == 'chegg' ? ProductType.CHEGG_WRITING : undefined,
      hostAnnotations: _objectSpread(_objectSpread({}, getHostAnnotations(analyticsInfo)), {}, {
        uvn: vCookie
      })
    });
  }
  if (screen === Screen.SUCCESS) {
    content = /*#__PURE__*/React.createElement(SuccessContent, {
      onHostRedirect: onHostRedirect,
      siteName: siteName
    });
  }
  return /*#__PURE__*/React.createElement(StyledContentWrapper, {
    screen: screen
  }, content, isModal && screen == Screen.PAYMENT && /*#__PURE__*/React.createElement(IconButton, {
    className: "close-button",
    screenReaderOnlyText: "Close",
    onClick: onClose,
    color: colors.dark
  }, /*#__PURE__*/React.createElement(CancelIcon, null)));
};
export default WtOneClick;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/WtOneClick/index.js
// module id = 2883
// module chunks = 11